const defaultNames = {
  'processmaker-modeler-start-event': 'Start Event',
  'processmaker-modeler-start-timer-event': 'Start Timer Event',
  'processmaker-modeler-signal-start-event': 'Signal Start Event',
  'processmaker-modeler-message-start-event': 'Message Start Event',
  'processmaker-modeler-conditional-start-event': 'Conditional Start Event',
  'processmaker-modeler-email-start-event': 'Email Start Event',
};

export default defaultNames;
